import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { HelperService } from '../../shared/services/helper.service';
import { environment } from '../../../environments/environment';
import { SidebarService } from '../../shared/services/sidebar.service';
import { PageMetadataService } from '../../shared/services/page-metadata.service';
import { HttpService } from '../../shared/services/http.service';

@Component({
  selector: 'app-wp-list',
  templateUrl: './wp-list.component.html',
  styleUrl: './wp-list.component.css',
})
export class WpListComponent implements OnInit, OnDestroy {
  env = environment;
  loading: boolean = false;
  memberWorkplaceListUrl = `${environment.opbBackendHost}/api/member/workpackage/list`;
  brandListSubs!: Subscription;
  themeListSubs!: Subscription;
  memberListSubs!: Subscription;
  wpListSubs!: Subscription;
  isSidebarOpen: boolean = false;
  breadCrumbItems: MenuItem[] | undefined;
  breadCrumbHome: MenuItem | undefined;
  wpLists: any = [];
  userData: any;
  helper = inject(HelperService);

  httpService = inject(HttpService);
  cookieService = inject(CookieService);
  sidebarService = inject(SidebarService);
  pageMetaData = inject(PageMetadataService);
  quarterlyOutcomesLists: any;
  businessThemeLists: any = [];
  brandLists: any = [];
  teamMembersLists: any = [];
  wpListData: any = {};
  filterCount: number = 0;

  getCookieData() {
    const authCookie = this.cookieService.get('auth');
    return authCookie;
  }

  constructor() {
  }

  ngOnDestroy() {
    this.brandListSubs?.unsubscribe();
    this.memberListSubs?.unsubscribe();
    this.themeListSubs?.unsubscribe();
    this.wpListSubs?.unsubscribe();
  }
  userTypeLists: any = [
    {
      key: 'owner',
      value: 'Owner',
    },
    {
      key: 'member',
      value: 'Member',
    },
  ];
  statusLists: any = [
    {
      key: '0',
      value: 'Approval Pending',
    },
    {
      key: '1',
      value: 'Not Started',
    },
    {
      key: '2',
      value: 'Ongoing',
    },
    {
      key: '3',
      value: 'Closed',
    },
    {
      key: '4',
      value: 'Rejected',
    },
  ];

  searchQuery: string = '';
  onSearchInput() {
    this.wpListData.search=this.searchQuery
    this.fetchWPLists(this.wpListData);
  }
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
  fetchThemeList() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/themes`, {})
      .subscribe((res: any) => {
        this.businessThemeLists = res?.data;
      });
  }

  getBrandList() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/workpackage/brands`, {})
      .subscribe((res: any) => {
        this.brandLists = res?.data;
      });
  }

  onDropdownSelection(filterData: any) {
    this.searchQuery = '';
    this.wpListData = filterData;
    this.filterCount = this.getFilledPropertiesCount(filterData);
    this.fetchWPLists(filterData);
  }

  getFilledPropertiesCount(data: any) {
    return Object.keys(data).filter(
      (key) => data[key] !== null && data[key] !== '' && data[key] != undefined
    )?.length;
  }

  ngOnInit(): void {
    this.pageMetaData.setTitle('WP-List | OBP');
    this.helper.fetchMembersList("member",{include_members: this.helper.loggedInUser?.user_id}).subscribe((response)=>{
      this.teamMembersLists=response.data
      this.sidebarService.selectedMember=response?.data?.find(
        (m: any) => m.user_id === this.helper.loggedInUser.user_id
      );
      this.sidebarService.wpData.year=new Date().getFullYear(),
      this.sidebarService.wpData.member_id=this.helper.loggedInUser.user_id
      this.onDropdownSelection({...this.sidebarService.wpData})

    })
    this.helper.fetchBrandList();
    this.helper.fetchThemeList();
    this.helper.fetchWPList();
    this.sidebarService.clearWPSelection();
    this.brandListSubs = this.helper.brandList$.subscribe((data: any) => {
      this.brandLists = data;
    });
    this.themeListSubs = this.helper.themeList$.subscribe((data: any) => {
      this.businessThemeLists = data;
    });
    this.wpListSubs = this.helper.wpList$.subscribe((data: any) => {
      this.wpLists = data;
    });
    const decodedData = window.atob(this.getCookieData());
    this.userData = JSON.parse(decodedData);
    this.breadCrumbItems = [
      { label: 'Work Packages' },
      { label: 'Work Packages List' },
    ];
    this.breadCrumbHome = { label: 'Home', routerLink: '/home' };
  }

  fetchWPLists(data?: any) {
    this.loading = true;
    this.httpService
      .post(this.memberWorkplaceListUrl, { page: 1, ...data })
      .subscribe((res: any) => {
        this.wpLists = res.data;
        this.loading = false;
      });
  }

  onDataLoaded(data: any[]) {
    this.wpLists = data;
  }

  createWpFormData(wpData: any) {
    this.wpLists.unshift(wpData);
  }

  wpListTeamMembers(data:any){
    if (Array.isArray(data)) {
      const combined = [...this.teamMembersLists, ...data];
      this.teamMembersLists = Array.from(
        new Map(combined.map(member => [member.user_id, member])).values()
      );
    } else if (data && typeof data === "object" && "user_id" in data) {
      const index = this.teamMembersLists.findIndex(
        (member: any) => member.user_id === data.user_id
      );
    
      if (index !== -1) {
        this.teamMembersLists[index] = data;
      } else {
        this.teamMembersLists.push(data);
      }
    }
  }

  updateFormWPFormData(updatedData: any) {
    const index = this.wpLists.findIndex(
      (wp: any) => wp.package_id == updatedData?.package_id
    );
    if (index !== -1) {
      this.wpLists.splice(index, 1, updatedData);
    }
  }
}
